<h1>Enter 2FA code</h1>

<p>Verify your identity by entering the 2FA code from your email or linked authenticator app.</p>
<form (submit)="onSubmit()">
  <sync-text-field
    class="twofa-code"
    label="2FA code"
    [(value)]="twofacode"
  />

  <sync-button
    nativeType="submit"
    class="submit"
    label="Submit"
    [isLoading]="spinner"
    [disabled]="!isFormValid"
    buttonWidth="236px"
  />
</form>

<div class="qa">
  <div class="entry" [class.open]="questionOpen('didnt-receive')">
    <span class="question" (click)="toggleQuestion('didnt-receive')">
      <sync-icon name="chevron-down" />
      I didn’t receive my 2FA code in my email
    </span>
    <div class="answer">
      <p>Codes are only sent by email to accounts with email-based 2FA enabled.</p>
      <p>If enabled, an email with your 2FA code should arrive in your inbox within 5 minutes. Please double check your junk or spam folders.  If you haven’t received an email after 5 minutes, then an incorrect username and password combination may be why you did not receive a 2FA code in your email.</p>
      <p>Try <a (click)="onClickLogin()">signing in</a> again, or <a routerLink="/forgot-password">resetting your password</a>.</p>
    </div>
  </div>

  <div class="entry" [class.open]="questionOpen('app-not-working')">
    <span class="question" (click)="toggleQuestion('app-not-working')">
      <sync-icon name="chevron-down" />
      My authenticator app code is not working
    </span>
    <div class="answer">
      <p>Codes from an authenticator app will only work for an account currently linked to the application.</p>
      <p>If your account is already linked, then an incorrect username and password combination may be why your 2FA code is not working.</p>
      <p>Try <a (click)="onClickLogin()">signing in</a> again, or <a routerLink="/forgot-password">resetting your password</a>.</p>
    </div>
  </div>

</div>
